// extracted by mini-css-extract-plugin
export var nav = "nav-module--nav--t0FTc";
export var logo = "nav-module--logo--bgJ5Y";
export var right = "nav-module--right--t-OT9";
export var joinBtn = "nav-module--joinBtn--2Z6mh";